<template>
  <span @click="trackExternalLinkClick">
    <a class="eh-link" :href="hrefUrl" :target="target"
    ><slot></slot>
      <div class="d-inline" v-if="showExternalIcon">
      <font-awesome-icon class="ml-1" icon="external-link-alt" size="sm"/>
        </div>
    </a>
  </span>
</template>

<script>
export default {
  name: "ExternalLink",
  props: {
    hrefUrl: String,
    event: {
      type: String,
      default: "Autodesk One - external link clicked",
    },
    subEvent: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: "_blank",
    },
  },
  computed: {
    showExternalIcon() {
      return this.target === "_blank"
    }
  },
  methods: {
    trackExternalLinkClick() {
      let subEvent = "";
      this.subEvent
          ? (subEvent = this.subEvent)
          : (subEvent = `url - ${this.hrefUrl}`);
      this.$hhMixpanel.trackEvent(this.event, {subEvent: subEvent});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ExternalLink.vue